<template>
  <div id="ProgramInfo">
    <Breadcrumb :title="'Program Information'"></Breadcrumb>
    <BaseSearchBar :config="SearchProgram" @keyupSearch="filterGrid"></BaseSearchBar>
    <BaseToolBar :config="ProgramInfoToolbarConfig" @buttonClicked="ProgramToolBarClick"></BaseToolBar>
    <ProgramInfoForm
      :ref="'ProgramInfo'"
      :unit-class-delete-items-array="UnitClassDeleteItemsArray"
      :vesting-delete-items-array="VestingDeleteItemsArray"
      :program-info-form-config="ProgramInfoJSON"
      :program-modal-label="modalConfig"
      :uploaded-file="ProgramFile" 
    ></ProgramInfoForm>

    <ProgramImportDropZoneForm
      :ref="'ProgramImport'"
      :program-info-template="ProgramInfoFormAddJSON"
      :import-modal-config="importModalConfig"
      @readComplete="onProgramTemplateReadComplete">
    </ProgramImportDropZoneForm>

    <BaseGrid
      :mode="'editform'"
      :excel-export="excelExport"
      :config="ProgramInfoGridConfig"
      @EditItem="EditProgram"
      @AttachItem="ProgramAttachment"
    ></BaseGrid>
    <ProgramDocumentDropoffForm
      ref="programDocument"
      :doc-modal-config="docModalConfig"
      :filter-condition="filterCondition"
      :transaction-record="selectedProgram"
    ></ProgramDocumentDropoffForm>
  </div>
</template>

<script>
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import $ from "jquery";
import {
  ProgramInfoGridConfig,
  ProgramInfoToolbarConfig
} from "./ProgramInfoConfig.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js";

import ProgramImportDropZoneForm from "@/components/forms/ProgramImportDropZoneForm.vue";
import ProgramInfoForm from "@/components/forms/ProgramInfoForm.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import customAxios from "@/services/customAxios.js";
import ProgramDocumentDropoffForm from "@/components/forms/ProgramDocumentDropoffForm.vue";
import { mapActions, mapGetters } from 'vuex';
import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";

export default {
  name: "ProgramInfo",
  components: {
    Breadcrumb,
    BaseGrid,
    ProgramInfoForm,
    BaseSearchBar,
    BaseToolBar,
    ProgramDocumentDropoffForm,
    ProgramImportDropZoneForm
  },
  mixins: [apiUtil, funcUtil, toolbarUtility],
  data: function() {
    return {
      ProgramInfoGridConfig: ProgramInfoGridConfig,
      ProgramInfoToolbarConfig: ProgramInfoToolbarConfig,
      ProgramInfoMasterData: [],
      //currentVestingClass: this.ProgramInfo.ClassType,
      SearchProgram: {
        SearchData: ""
      },
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      programGridId: "programGrid",
      ProgramInfoJSON: { parent: {}, children: {} },
      ProgramInfoFormAddJSON: {
        parent: {
          Id: null,
          Title: "",
          Alias: "",
          EIN: "",
          FormationDate: null,
          InitialAwardDate: null,
          FinalCloseDate: null,
          MultiClass: "",
          IncomeSource: [],
          StateSource: [],
          Note: ""
        },
        children: {
          UnitClass: [],
          VestingSchedule: []
        }
      },
      ProgramInfoFormEditJSON: {
        parent: {
          Id: "",
          Title: "",
          Alias: "",
          EIN: "",
          FormationDate: "",
          InitialAwardDate: "",
          FinalCloseDate: "",
          MultiClass: "",
          IncomeSource: [],
          StateSource: [],
          Note: ""
        },
        children: {
          UnitClass: [],
          VestingSchedule: []
        }
      },
      UnitClassDeleteItemsArray: [],
      VestingDeleteItemsArray: [],

      // Document dropoff modal
      docModalConfig: {
        modalName: "Program Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
       // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedProgram:{},
      importModalConfig:{
        modalName: "Import Program",
        modalIdandRef: "importModalConfig",
        isFooter: false
      },
      ProgramFile:"" 
    };
  },
  computed:{
      ...mapGetters("getModule",["getJoinedItemsFilter","ListArraysPopulated","isListReady","listHasData"]),
      ...mapGetters("authModule", ["userIsAuthenticated"]),
      myListIsReady(){
         //console.log('myListIsReady()....')
         let rd = this.isListReady('Program');
         return rd;
      },
      myListDataStatus() {
          return this.$store.state.getModule.Program.length != 0
      }
  },

 watch: {
    //  myListIsReady: function(newval){
    // },
    // myListDataStatus: function(newval, oldval){
    //   if (newval == true && oldval == false){
    //     console.log(`${Date.now()}-mytag----- [ProgramInfo.vue] myListDataStatus WATCH    ------------- newval=${newval}   oldval=${oldval}`)
    //  //   this.refreshGrid();
    //   }

    // }
   
  },

  mounted() {
    let self = this;
    //changes for Toolbar
    self._loadGridSettings(self.programGridId);

    //bind databound event to grid
    let grid = $("#programGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateProgramInfoMasterData);
    grid.dataSource.fetch();
   
  },
  methods: {    
    UpdateProgramInfoMasterData: function(fromFilter, filterMasterData) {
       let grid = $("#programGrid").data("kendoGrid");
       
      if (fromFilter == true) {
        this.ProgramInfoMasterData = filterMasterData;
      } else {
        this.ProgramInfoMasterData = JSON.parse(
          JSON.stringify(
            $("#programGrid")
              .data()
              .kendoGrid.dataSource.data()
          )
        );
      }
    },

    ProgramToolBarClick: function(e) {
      e.preventDefault();
      switch (e.id) {
        case "btnAddProgram":
           this.ProgramFile="";
            this.AddProgram();
            window.$("#BaseModal").find(".panel").css("display","none");
            window.$("#BaseModal").modal("toggle");
          break;
        case "btnImportProgram":
            //Remove All the Files Already Present in the DropZone
            this.$refs.ProgramImport.$refs.programImportDropZone.$refs.FileUploaded.removeAllFiles();
            this.ProgramInfoFormAddJSON.parent.Id = "";
            this.ProgramInfoFormAddJSON.parent.Title = "";
            this.ProgramInfoFormAddJSON.parent.Alias = "";
            this.ProgramInfoFormAddJSON.parent.FormationDate = "";
            this.ProgramInfoFormAddJSON.parent.InitialAwardDate = "";
            this.ProgramInfoFormAddJSON.parent.MultiClass = "";
            this.ProgramInfoFormAddJSON.parent.IncomeSource = [];
            this.ProgramInfoFormAddJSON.parent.StateSource = [];
            this.ProgramInfoFormAddJSON.parent.EIN = "";
            this.ProgramInfoFormAddJSON.parent.Note = "";
            this.ProgramInfoFormAddJSON.parent.ProgramID = "";
            this.ProgramInfoFormAddJSON.parent.InvestmentId = [];
            this.ProgramInfoFormAddJSON.children.UnitClass = [];
            this.ProgramInfoFormAddJSON.children.VestingSchedule = [];

            this.importModalConfig.modalName = "Import Program";
            window.$("#importModalConfig").modal("toggle");
          break;
        case "btnDownloadProgramTemplate":
           let token = localStorage.getItem(`${process.env.VUE_APP_EUM_ID_TOKEN}`)
           let tokenstr = `Bearer ${token}`
           let templateUrl = getUrl("ProgramInformationImport");
           let templateFileName = getFileName("ProgramInformationImport");
            
           customAxios({
              url: templateUrl,
              method: 'GET',
              headers: {
                'Authorization': tokenstr
              },
              responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });
     
          break;
      }
      this._baseToolBarEvents(this.programGridId, ...arguments);
    },
    refreshGrid: function() {
      $("#programGrid")
        .data()
        .kendoGrid.dataSource.read();
      // alert("Data Refreshed!");
    },
    filterGrid: function() {
      let self = this;
      let currentMasterdata = this.ProgramInfoMasterData;

      let filteredData = this._filterGrid(
        this.ProgramInfoMasterData,
        this.SearchProgram.SearchData
      );
      $("#programGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      this.UpdateProgramInfoMasterData(true, currentMasterdata);
    },
    AddProgram: function() {
      this.modalConfig.modalName = "Add Program";
      this.modalConfig.modalAddorEdit = "add";
      this.VestingDeleteItemsArray = [];
      this.UnitClassDeleteItemsArray = [];
      this.ProgramInfoJSON = this.ProgramInfoFormAddJSON;
      this.ProgramInfoFormAddJSON.parent.Id = "";
      this.ProgramInfoFormAddJSON.parent.Title = "";
      this.ProgramInfoFormAddJSON.parent.Alias = "";
      this.ProgramInfoFormAddJSON.parent.FormationDate = "";
      this.ProgramInfoFormAddJSON.parent.InitialAwardDate = "";
      this.ProgramInfoFormAddJSON.parent.MultiClass = "";
      this.ProgramInfoFormAddJSON.parent.IncomeSource = [];
      this.ProgramInfoFormAddJSON.parent.StateSource = [];
      this.ProgramInfoFormAddJSON.parent.EIN = "";
      this.ProgramInfoFormAddJSON.parent.Note = "";
      this.ProgramInfoFormAddJSON.parent.ProgramID = "";
      this.ProgramInfoFormAddJSON.parent.InvestmentId = [];
      this.ProgramInfoFormAddJSON.children.UnitClass = [];
      this.ProgramInfoFormAddJSON.children.VestingSchedule = [];
      this.$refs.ProgramInfo.$refs.refProgramForm.errors.clear();
    },
    EditProgram: function(e) {
      e.preventDefault();
      this.modalConfig.modalName = "Edit Program";
      this.modalConfig.modalAddorEdit = "edit";
      //alert("Edit button clicked from BaseGrid..");
      let gview = window.$("#programGrid").data("kendoGrid");
      let dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      let dataItem = JSON.parse(JSON.stringify(dataItem1));
      this.VestingDeleteItemsArray = [];
      this.UnitClassDeleteItemsArray = [];

      //Get joined items

        let response = this.getJoinedItemsFilter({
            parentConfig: ProgramInfoGridConfig,
            parentId: dataItem.Id,
            keyToJoin: "Program/Id",
            childConfigs: [BaseModelUnitClass, BaseModelVestingSchedule]
          })

        
        this.ProgramInfoFormEditJSON = JSON.parse(JSON.stringify(response));
        if(response.parent.StateSource != null && response.parent.StateSource != undefined){
          if (response.parent.StateSource.constructor != Array) {
            this.ProgramInfoFormEditJSON.parent.StateSource = response.parent.StateSource.split(
              ","
            );
          }
        }
        if(response.parent.IncomeSource != null && response.parent.IncomeSource != undefined){
          if (response.parent.IncomeSource.constructor != Array) {
            this.ProgramInfoFormEditJSON.parent.IncomeSource = response.parent.IncomeSource.split(
              ","
            );
          }
        }
        let InvestmentIdArray = [];
        InvestmentIdArray.push(response.parent.InvestmentId);
        this.ProgramInfoFormEditJSON.parent.InvestmentId = InvestmentIdArray;
        this.ProgramInfoJSON = this.ProgramInfoFormEditJSON;
        this.$refs.ProgramInfo.$refs.refProgramForm.disableDone=false;
        this.$refs.ProgramInfo.$refs.refProgramForm.lockVestingSchedule=true;
//window.$("#BaseModal").find(".panel").css("display","none");
        
           window.$("#BaseModal").modal("toggle");
        
          
    },

    DeleteItemfromGrid: function(e) {
      e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");
      let getconfirm = false;
      getconfirm = this.getConfirmation();
      if (getconfirm) {
        let gview = window.$("#programGrid").data("kendoGrid");
        let dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      }
    },
    getConfirmation: function() {
      let retVal = confirm("Are you sure you want to delete this record?");
      if (retVal == true) {return true;}
      else {return false;}
    },

    // Program Documnet Dropoff
    ProgramAttachment: function(e) {
      let self = this;
      e.preventDefault();
      let gview = window.$("#programGrid").data("kendoGrid");
      let dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedProgram={...dataItem};
      this.selectedProgram.PartnerTitle=null
      this.selectedProgram.PartnerId=null
      this.selectedProgram.ProgramTitle=dataItem.Title
      this.selectedProgram.ProgramId=dataItem.Id
      this.selectedProgram.BusinessEvent="Program"

      this.filterCondition.batchQuery=true;

      this.filterCondition.filter = function(o){
        let programIdList=(o.ProgramIdList) ? o.ProgramIdList.split(",").map(Number):[]
        return o.ProgramId == dataItem.Id || programIdList.includes(dataItem.Id)
      }

      //this.filterCondition.filter = `ProgramId eq '${dataItem.Id}'`;

      self.$refs.programDocument.$refs.programDocumentMgr.resetDropZoneGrid();

      window.$("#docModal").modal("toggle");
    },
    onProgramTemplateReadComplete(files){
      this.ProgramFile = files;
      console.log(this.ProgramInfoFormAddJSON)
      //this.ProgramInfoJSON={}
      this.modalConfig.modalName = "Add Program";
      this.modalConfig.modalAddorEdit = "add";
      //this.VestingDeleteItemsArray = [];
      //this.UnitClassDeleteItemsArray = [];
      this.ProgramInfoJSON = this.ProgramInfoFormAddJSON;
      this.$refs.ProgramInfo.$refs.refProgramForm.errors.clear();
      window.$("#importModalConfig").modal("toggle");
      window.$("#BaseModal").modal("toggle");
    }
  }
};
</script>
